import { useEffect, useState } from "react";
import { Flex } from "@chakra-ui/react";
import Header from "./components/Header";
import Filters from "./components/Filters";
import columns from "./components/columns";
import useGetConfigFiltrosCultura from "./hooks/useGetConfigFiltrosCultura";

import { Counter, RoundedTable } from "./styles";

function ConfiguracaoFiltrosCulturas() {
  const [filters, setFilters] = useState<any>();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);

  const { data, isLoading } = useGetConfigFiltrosCultura(
    page,
    pageSize,
    filters,
  );

  useEffect(() => {
    if (data) {
      setTotal(data?.paginate?.totalCount);
    }
  }, [data]);

  return (
    <Flex flex={1} bgColor="white" flexDir={"column"}>
      <Header />

      <Filters data={data?.data} handleFilter={setFilters} />

      <Counter>
        <b>Culturas Configuradas</b>
        <p>{total} Culturas</p>
      </Counter>

      <RoundedTable
        style={{ margin: 16 }}
        columns={columns}
        loading={isLoading}
        dataSource={data?.data}
        pagination={{
          total,
          pageSize,
          current: page,
          showSizeChanger: true,
          onChange: (page: number, pageSize: number) => {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />
    </Flex>
  );
}

export default ConfiguracaoFiltrosCulturas;
